import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { STATUS_BADGE_COLOR, StatusBadgeTone } from '@/components/domain/seminar/seminarDisplay';

/*
 * 상세 히어로 — 16:9, 반경 12px. 원본 썸네일 하나만 쓴다(모바일 썸네일 X).
 * 카드와 같이 object-fit: cover 로 프레임을 꽉 채운다(썸네일은 업로드 때 16:9 로 자르므로 잘림 없음).
 * 배지: 오른쪽 위 상태 하나만, 작게(모바일 18px · PC 20px). 진행 방식·쿠폰은 정보 표·참가비와 겹쳐 두지 않는다.
 */

const HeroBox = styled.div<{ empty: boolean }>`
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  border-radius: 12px;
  overflow: hidden;
  background: ${({ empty }) => (empty ? '#eef1f0' : '#111827')};
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9ca3af;
  font-size: 13px;
`;

const ForegroundImage = styled.img`
  position: relative;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
`;

/** 오른쪽 위 상태 배지 하나만 — 작게(모바일 18px · PC 20px). 진행 방식·쿠폰은 정보 표와 겹쳐 두지 않는다 */
const StatusBadge = styled('span', { shouldForwardProp: (prop: string) => prop !== 'textColor' })<{ textColor: string }>`
  position: absolute;
  z-index: 1;
  right: 8px;
  top: 8px;
  height: 18px;
  line-height: 18px;
  padding: 0 6px;
  border-radius: 9px;
  font-size: 11px;
  font-weight: 800;
  white-space: nowrap;
  background: rgba(255, 255, 255, 0.9);
  color: ${({ textColor }) => textColor};
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);

  @media (min-width: 769px) {
    right: 10px;
    top: 10px;
    height: 20px;
    line-height: 20px;
    padding: 0 7px;
    border-radius: 10px;
  }
`;

interface DetailHeroProps {
  imageUrl?: string;
  statusBadge: { text: string; tone: StatusBadgeTone } | null;
}

const DetailHero: React.FC<DetailHeroProps> = ({ imageUrl, statusBadge }) => {
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [imageUrl]);
  const showImage: boolean = Boolean(imageUrl) && !failed;
  return (
    <HeroBox empty={!showImage}>
      {showImage ? (
        <ForegroundImage src={imageUrl} alt="세미나 썸네일" onError={() => setFailed(true)} />
      ) : (
        <span>썸네일 이미지가 없습니다</span>
      )}
      {statusBadge && <StatusBadge textColor={STATUS_BADGE_COLOR[statusBadge.tone]}>{statusBadge.text}</StatusBadge>}
    </HeroBox>
  );
};

export default DetailHero;
